import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_ENDPOINT } from '../../constants/constants';
import { getHeader } from '../../utils/util';
import { SketchPicker } from 'react-color';
import { toast } from 'react-toastify';
import ConfigItem from '../widgets/ConfigItem';

// The badge colour is painted behind white text on the trainer's top-up card,
// so it has to be a dark tone. White (the old default) made the badge vanish.
const DEFAULT_TOPUP_COLOR = '#5B4BFF';

const AddTopup = ({ plan, mode, onActionDone, show }) => {
    const [loading, setLoading] = useState(false)
    const [name, setName] = useState('');
    const [price, setPrice] = useState('');
    const [count, setCount] = useState('');
    const [discount, setDiscount] = useState('');
    const [color, setColor] = useState(DEFAULT_TOPUP_COLOR);
    const [validity, setValidity] = useState('');
    const [showColorPicker, setShowColorPicker] = useState(false);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (plan !== null && plan !== undefined) {
            setName(plan.name || '');
            setPrice(plan.price || '');
            setCount(plan.count || '');
            setDiscount(plan.discount || '');
            setColor(plan.color || DEFAULT_TOPUP_COLOR);
            setValidity(plan.validity || '');
            setIsActive(plan.isActive || false);
        } else {
            setName(''); setPrice(''); setCount(''); setDiscount('');
            setColor(DEFAULT_TOPUP_COLOR); setValidity(''); setIsActive(false);
        }
    }, [show, plan]);

    const onAdd = () => {
        if (name === '') { toast.error("Please enter name"); return }
        if (price === '') { toast.error("Please enter price"); return }
        if (count === '') { toast.error("Please enter candidate count"); return }
        if (discount === '') { toast.error("Please enter discount"); return }

        const planO = { name, price, count, discount, color, validity, isActive }
        let dataObj = { plan: planO }
        if (mode === "view") dataObj.id = plan._id

        setLoading(true)
        axios.post(API_ENDPOINT + `admin/${mode === "add" ? "add-topup" : "update-topup"}`, dataObj, getHeader()).then(res => {
            const d = res.data
            setLoading(false)
            if (d.success) {
                toast.success(`${mode === "add" ? "Added" : "Updated"} successfully`)
                onActionDone()
            } else {
                toast.error(d.message || "Something went wrong")
            }
        }).catch(() => { setLoading(false); toast.error("Request failed") })
    }

    return (
        <div style={{ maxWidth: 600, margin: 'auto', position: 'relative' }}>
            <div className="field" style={{ marginBottom: 14 }}>
                <label>Name</label>
                <input className="input" value={name} onChange={e => setName(e.target.value)} />
            </div>
            <div className="field" style={{ marginBottom: 14 }}>
                <label>Price</label>
                <input className="input" type="number" value={price} onChange={e => setPrice(e.target.value)} />
            </div>
            <div className="field" style={{ marginBottom: 14 }}>
                <label>Candidate Count</label>
                <input className="input" type="number" value={count} onChange={e => setCount(e.target.value)} />
            </div>
            <div className="field" style={{ marginBottom: 14 }}>
                <label>Discount</label>
                <input className="input" type="number" value={discount} onChange={e => setDiscount(e.target.value)} />
            </div>

            <div
                style={{ height: 48, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', backgroundColor: color, color: '#fff', border: '1px solid var(--color-divider)', margin: '12px 0', userSelect: 'none', fontSize: 13 }}
                onClick={() => setShowColorPicker(!showColorPicker)}
            >
                current color: {color}. click here to change
            </div>
            {showColorPicker && (
                <div style={{ position: 'absolute', bottom: 0, zIndex: 50 }}>
                    <SketchPicker color={color} onChangeComplete={(c) => { setColor(c.hex); setShowColorPicker(false) }} />
                </div>
            )}

            <ConfigItem text='Is Topup Active?' checked={isActive} setChecked={setIsActive} />
            <button className="btn btn-primary" onClick={onAdd} disabled={loading} style={{ margin: '16px 0', width: '100%' }}>
                {loading ? 'Saving…' : 'Submit'}
            </button>
        </div>
    );
};

export default AddTopup;
